export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f63fccf37db5b47977bb776cc0669dcf27158401f&name=fetchTypeahead!'